@use "variables" as *;

.image {
  max-width: 24%;
  margin-bottom: $spacing-m;
}

.imageOrder {
  max-width: 50%;
  margin-bottom: $spacing-m;
}

.imageFloatRight {
  float: right;
  margin-left: $spacing-m;
  margin-bottom: $spacing-s;
  max-width: 50%;
}
